
import { PAGE_TYPE, QUERY_BLOG_DETAIL } from "./-index.query";
import { seoMixin, pageMixin } from "~/mixins";
import { getBlogBreadcrumbSchemaScript } from "~/utils/blogs-breadcrumb-schema";

export default {
  mixins: [seoMixin, pageMixin],

  async asyncData({ app, params: { handle }, error }) {
    const [{ data: blogData }, { [PAGE_TYPE]: data }] = await Promise.all([
      app.$search.blogSearch({ query: handle, pageSize: 1 }),
      app.$prismicGql.request({
        query: QUERY_BLOG_DETAIL,
        variables: { uid: handle },
      }),
    ]);

    if (!data) {
      return error({ statusCode: 404, message: "Page not found" });
    }

    const searchspringBlog = blogData.results[0] || {};

    const blog = {
      ...data,
      next_blog: searchspringBlog?.next_blog,
      prev_blog: searchspringBlog?.prev_blog,
      published_date: searchspringBlog?.published_date,
    };

    return {
      blog,
      uid: handle,
      title: blog.title,
      pageType: PAGE_TYPE,
      metaTitle: blog.metaTitle,
      metaDescription: blog.metaDescription,
      metaRobots: blog.metaRobots,
      metaFields: { _linkType: blog._linkType, _meta: blog._meta },
    };
  },

  computed: {
    imgAlt() {
      return this.blog.feature_image.alt ?? this.$prismic.asText(this.title);
    },
    imgProps() {
      return {
        src: this.blog.feature_image.url,
        alt: this.imgAlt,
        width: this.blog.feature_image.dimensions?.width,
        height: this.blog.feature_image.dimensions?.height,
        fit: "cover",
        sizes: "md:100vw lg:100vw xl:1400px",
        modifiers: { aspectRatio: "4:1" },
      };
    },
    additionalScripts() {
      const baseUrl = this.$config.appEndPoint;

      return [
        {
          hid: "blog-schema",
          type: "application/ld+json",
          innerHTML: JSON.stringify(this.blogSchema),
        },
        ...getBlogBreadcrumbSchemaScript({
          baseUrl,
          hid: "blog-detail-breadcrumb-schema",
          currentPage: {
            name: this.$prismic.asText(this.title)?.trim(),
            item: `${baseUrl}${this.$route.path}`,
          },
        }),
      ];
    },
    blogSchema() {
      const schema = {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: this.$prismic.asText(this.title)?.trim(),
        description: this.metaDescription?.trim(),
        image: [
          this.blog.feature_image?.url,
          this.blog.feature_image?.list_image?.url,
          this.blog.feature_image?.tile_image?.url,
        ].filter(Boolean),
        datePublished: this.blog._meta.firstPublicationDate,
        dateModified: this.blog._meta.lastPublicationDate,
        author: {
          "@type": "Organization",
          name: "Snooze",
          url: "https://www.snooze.com.au",
        },
        publisher: {
          "@type": "Organization",
          name: "Snooze",
          logo: {
            "@type": "ImageObject",
            url: `${this.$config.appEndPoint}/images/logo.svg`,
          },
        },
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": `${this.$config.appEndPoint}${this.$route.path}`,
        },
      };

      if (this.blog._meta.tags?.length) {
        schema.keywords = this.blog._meta.tags.join(", ");
      }

      return schema;
    },
  },
};
